import { render, staticRenderFns } from "./templatesList.vue?vue&type=template&id=0c975afa&"
import script from "./templatesList.vue?vue&type=script&lang=js&"
export * from "./templatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports